import { mount } from "zyra";
import "@fontsource-variable/inter";
import '@zyra/ui/styles.css';
import "./styles/index.css";
import { App } from "./app/App";

mount(App, document.querySelector("#app")!);
